/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/transfer_to'
export default icon
